<template>
  <div>
    <transition name="fade" appear>
      <Header ref="header" />
    </transition>

    <main role="main" id="main">
      <router-view ref="currentView" v-slot="{ Component }">
        <transition name="fade" appear>
          <component :is="Component"></component>
        </transition>
      </router-view>
      <transition name="loader" mode="out-in">
        <img class="loader siteLoader" src="@/assets/images/loader.svg" alt="Chargement" v-if="onLoad" />
      </transition>
    </main>

    <transition name="fade" appear>
      <Footer ref="footer" />
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Footer from '@/components/partials/TheFooter'
import Header from '@/components/partials/TheHeader'

export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {}
  },
  computed: {
    ...mapState([
      'onLoad',
    ]),
  }
}
</script>
<style lang="scss" >
  @import "app.scss";
  @import "@/scss/helpers/mixins";
  @import "@/scss/helpers/variables";

  ::placeholder {
    color: #283861;
    font-size: 15px;
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  main {
    background-color: #F5F5F5;
  }

  .heading-1 {
    margin: 0 0 12px;
    font-family: $campaign;
    font-size: 22px;
    font-weight: $bold;
    line-height: 1;

    @include min($lg) {
      font-size: 35px;
    }
  }

  //form 
  .form-group {
    margin: 0 0 15px;

    @include min($lg) {
      margin: 0 0 10px;
    }
  }

  input[type="text"],
  input[type="password"],
  input[type="email"],
  select,
  textarea {
      width: 100%;
      background: $inputgray;
      box-shadow: inset 0px 3px 3px rgba(40, 56, 97, 0.102);
      border-radius: 25px;
      padding: 11px 16px;
      display: block;
      color: $main;
      font-size: 15px;
      font-weight: $regular;
      min-height: 40px;
      border: none;
  }

  textarea {
    min-height: 100px;
    resize: vertical;

    background: url('@/assets/images/expand.svg') 97% 90% no-repeat $inputgray;
  }

  ::-webkit-resizer {
    display: none;
  }

  [type=checkbox] {
    opacity: 0;
    width: 20px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    cursor: pointer;

      &:checked~label,
      &:not(:checked)~label {
        padding-left: 25px;
        position: relative;
        display: block;

        &:before{
          content: '';
          width: 20px;
          height: 20px;
          border-radius: 5px;
          position: absolute;
          left: 0;
          top: 1px;
          background: $inputgray2;
        }
      }

      &:checked~label {
        &:after {
          content: "";
          width: 20px;
          height: 20px;
          position: absolute;
          top: 0;
          left: 0;
          background: url('@/assets/images/checked.svg') 50% 50% no-repeat $inputgray2;
        }
      }
    }

</style>